import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)
// 解决导航栏重复点击跳转报错报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/index')
    },
    // corp
    {
      path: '/corp',
      name: 'corp',
      component: () => import('@/views/corp')
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('@/views/download')
    },
    // // 隐私政策
    // {
    //   path: '/PrivacyPolicy',
    //   name: 'PrivacyPolicy',
    //   component: () => import('@/views/PrivacyPolicy')
    // },
    // // 用户协议 
    // {
    //   path: '/userAgreement',
    //   name: 'userAgreement',
    //   component: () => import('@/views/userAgreement')
    // },
    // // 免责说明 
    // {
    //   path: '/disclaimer',
    //   name: 'disclaimer',
    //   component: () => import('@/views/disclaimer')
    // },
    // {
    //   path: '/healthDataSources',
    //   name: 'healthDataSources',
    //   component: () => import('@/views/healthDataSources')
    // },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js